import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Injector,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';

import { FbTextareaWidget } from '../../../models';
import { Widget } from '../../../models/form-widget.model';
import { WidgetBase } from '../../../models/widget-base';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TokenToDivPipe } from '../../../helpers/token-to-div.pipe';
import { ContentEditableModelDirective } from '../../../helpers/content-editable-model.directive';
import { ScribeSuggestionIndicatorComponent } from '../shared/scribe-suggestion-indicator/scribe-suggestion-indicator.component';
import { AmendmentFieldIndicatorComponent } from '../shared/amendment-field-indicator/amendment-field-indicator.component';

@Component({
  selector: 'app-fb-textarea',
  templateUrl: './fb-textarea.component.html',
  styleUrls: ['./fb-textarea.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    TokenToDivPipe,
    ContentEditableModelDirective,
    ScribeSuggestionIndicatorComponent,
    AmendmentFieldIndicatorComponent,
  ],
})
export class FbTextareaComponent extends WidgetBase implements OnInit {
  @Input()
  public override set payload(value) {
    this._payload = value;
    this.ready.next(true);
  }
  public override get payload() {
    return this._payload;
  }

  constructor(private injector: Injector) {
    super(injector);
  }

  ngOnInit() {}

  override isValid() {
    return new FbTextareaWidget(this.payload).isValid();
  }
}
